import React from "react";
import ColumnHeaders from "./ColumnHeaders";
import Groups from "./Groups";
import { HeaderProps } from "./types";

const GroupHeaders: React.FC<HeaderProps> = ({
  group,
  gridTemplate,
  minTableWidth,
  cols,
  setCols,
  boardData,
  selectedTickets,
  sortByColumn,
  sortByOrder,
  handleSort,
  groupLoading,
  onCommitColumnWidths,
}) => {
  return (
    <div className="sticky top-0 z-30 ">
      <div className="relative flex flex-col">
        {/* group header bar */}
        <Groups
          boardData={boardData}
          selectedTickets={selectedTickets}
          group={group}
          loading={groupLoading}
          minTableWidth={minTableWidth}
        />

        {/* column headers */}
        {!group.isCollapse && (
          <div className=" pe-[24px] ps-[62px] ">
            <ColumnHeaders
              gridTemplate={gridTemplate}
              minTableWidth={minTableWidth}
              cols={cols}
              setCols={setCols}
              sortByColumn={sortByColumn}
              sortByOrder={sortByOrder as string}
              handleSort={() => handleSort?.(group._id)}
              onCommitColumnWidths={onCommitColumnWidths}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupHeaders;
